function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.125 0.828125C1.35938 0.59375 1.6875 0.59375 1.92188 0.828125L11.7656 10.625C11.9531 10.8594 11.9531 11.1875 11.7656 11.4219L1.92188 21.2188C1.6875 21.4531 1.35938 21.4531 1.125 21.2188L0.1875 20.3281C0 20.0938 0 19.7188 0.1875 19.5312L8.67188 11L0.1875 2.51562C0 2.32812 0 1.95312 0.1875 1.71875L1.125 0.828125Z",
  fill: "#currentColor"
});

function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.54d79a0c3d2da7d220c4f75a16a28c00.svg";
export { ForwardRef as ReactComponent };